var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F9C011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33175 3.375C9.18563 3.87394 9.98887 4.45162 10.8349 4.96406L7.71638 10.404C7.30238 9.67781 6.91425 8.937 6.50531 8.20687C7.09425 6.58969 7.767 5.00063 8.33175 3.375ZM5.625 14.625C7.39069 11.4137 9.225 8.23781 10.971 5.01806C11.4379 5.83762 11.9053 6.65663 12.375 7.47619C11.0216 9.85669 9.65812 12.2316 8.31544 14.6171C7.41825 14.6171 6.52219 14.6059 5.625 14.625ZM8.48362 14.6121C9.23175 13.3324 9.93656 12.0302 10.6942 10.7561C11.1459 11.3338 11.6044 11.9081 12.0527 12.4886C10.8673 13.2036 9.67756 13.9114 8.48362 14.6121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnis);
export default __webpack_public_path__ + "static/media/ignis.c676eb66e9a7d255ed3f9ed41b3e0e16.svg";
export { ForwardRef as ReactComponent };